import type {
  CertificateListServiceConfig,
  GetCertificateCSVConfig,
} from '@/services/httpServices/CertificateServices/types';

import { createQueryKey } from './queryKeyUtils';

export function certificateCsvLanguagesListKeys(params?: GetCertificateCSVConfig) {
  return createQueryKey(['certificateLanguages'], params);
}

export function certificateListKeys(params?: CertificateListServiceConfig) {
  return createQueryKey(['certificateList'], params);
}
